import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import Content, { HTMLContent } from '../components/Content';
import { ContactForm } from '../views/contact-form';
import PreviewCompatibleImage from '../components/PreviewCompatibleImage';
import { openLightbox } from '../actions/lightbox';
import { Contacts } from '../components/contacts';

export const MultipleSectionsArticleTemplate = ({
  title,
  sections,
  contentComponent,
  location,
}) => {
  const PageContent = contentComponent || Content;

  return (
    <section className="section">
      <div className="container">
        <h1 className="title is-1 has-text-centered">{title}</h1>
        {sections.map((section) => (
          <section style={{ padding: '2rem 0' }} key={section.title}>
            <h2 className="title is-2">{section.title}</h2>
            <PageContent className="content" content={section.content} />
            {!!(section.images && section.images.length) && (
              <div className="columns is-multiline">
                {section.images.map(({ image }, index) => (
                  <div
                    className="column is-one-quarter"
                    key={image.preview.fluid.src}
                    onClick={() =>
                      openLightbox(location, {
                        fluids: section.images.map((image) => image.image.original.fluid),
                        index,
                      })
                    }
                  >
                    {image && <PreviewCompatibleImage fluid={image.preview.fluid} />}
                  </div>
                ))}
              </div>
            )}
          </section>
        ))}
        <hr />
        <h4 className="title is-4">
          Есть идеи для сотрудничества? Напиши в форму обратной связи или свяжись со мной любым
          удобным способом.
        </h4>
        <div className="columns">
          <div className="column">
            <Contacts />
          </div>
          <div className="column">
            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  );
};

const MultipleSectionsArticle = ({ data, location }) => {
  const { markdownRemark } = data;

  return (
    <Layout location={location} title={markdownRemark.frontmatter.title}>
      <MultipleSectionsArticleTemplate
        contentComponent={HTMLContent}
        title={markdownRemark.frontmatter.title}
        sections={markdownRemark.frontmatter.sections}
        location={location}
      />
    </Layout>
  );
};

export default MultipleSectionsArticle;

export const multipleSectionsArticleQuery = graphql`
  query MultipleSectionsArticle($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
        sections {
          title
          content
          images {
            image {
              preview: childImageSharp {
                fluid(maxWidth: 800, maxHeight: 600, quality: 65) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
              original: childImageSharp {
                fluid(maxWidth: 500) {
                  originalImg
                  src
                }
              }
            }
          }
        }
      }
    }
  }
`;
